export const DASHBOARD = 'dashboard';
export const DASHBOARD_LABEL = 'ra.page.dashboard';
